<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <div class="min-h-screen pb-16 bg-gray-50/40">
        <!-- Page header -->
        <section class="pt-28">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="max-w-2xl mx-auto text-center">
              <span
                class="inline-flex items-center gap-2 px-3 py-1 mb-3 text-xs font-semibold tracking-wide uppercase rounded-full text-primary bg-primary/10"
              >
                <span
                  class="inline-block w-1.5 h-1.5 rounded-full bg-primary"
                ></span>
                Tentang
              </span>
              <h1
                class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl font-roboto-slab"
              >
                Profil
              </h1>
              <p class="mt-4 text-base leading-relaxed text-gray-500">
                Tentang Dewan Pengawas Badan Layanan Umum.
              </p>
            </div>
          </div>
        </section>

        <!-- Content -->
        <section class="mt-12">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="flex flex-col gap-8 lg:flex-row lg:gap-10">
              <!-- Image -->
              <div class="flex-shrink-0 w-full lg:w-[380px]">
                <div class="lg:sticky lg:top-24">
                  <img
                    :src="`/storage/images/BGUNG.png`"
                    alt="Gedung Universitas Negeri Gorontalo"
                    class="object-cover w-full shadow-sm rounded-2xl ring-1 ring-gray-100"
                  />
                </div>
              </div>

              <!-- Text -->
              <div class="flex-1 w-full min-w-0">
                <div
                  class="p-6 bg-white border border-gray-100 shadow-sm sm:p-8 lg:p-10 rounded-2xl"
                >
                  <h2
                    class="pb-4 mb-6 text-xl font-bold text-gray-900 border-b border-gray-100 font-roboto-slab"
                  >
                    Tentang
                  </h2>
                  <div
                    class="max-w-none prose prose-gray prose-headings:font-roboto-slab prose-a:text-primary"
                    v-html="profil?.data?.[0]?.tentang"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";

const props = defineProps({
  profil: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
/* Ensure ordered/unordered lists from the editor render correctly inside prose */
.prose :deep(ol) {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin: 1rem 0;
}

.prose :deep(ul) {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin: 1rem 0;
}

.prose :deep(li) {
  margin-bottom: 0.5rem;
  line-height: 1.7;
}

.prose :deep(p) {
  margin: 0.75rem 0;
  line-height: 1.8;
}
</style>
